import React from 'react';
import { PropTypes } from 'prop-types';
import Modal from 'react-modal';
import { Icons, Button } from 'sarsaparilla';

const propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func
};

export default class UnauthorizedErrorModal extends React.Component {
  renderModalHeader() {
    return (
      <div>
        No Commercial Authorization
      </div>
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.closeModal}
        shouldCloseOnOverlayClick={false}
        role="complementary"
        className={{
          base: 'rec-modal-dialog-base',
          afterOpen: 'rec-modal-dialog-after-open-md per-unauth-modal',
          beforeClose: 'rec-modal-dialog-before-close'
        }}
        overlayClassName={{
          base: 'rec-overlay-base',
          afterOpen: 'rec-overlay-after-open',
          beforeClose: 'rec-overlay-before-close'
        }} >
        <div className="rec-modal-content-wrap">
          <Button
            className="rec-close-modal"
            onClick={this.props.closeModal}
            appearance="link"
            iconBeforeElement={<Icons.IconClose />}
            screenReaderTextBefore="Close the modal" />
          <div className="per-unauth-modal-title-block">
            <h4>No Commercial Authorization</h4>
          </div>
          <p> You are not authorized to make commercial reservations at this location, please contact the facility for more information.</p>
        </div>
        <div className="rec-modal-actions-wrap">
          <Button
            appearance="tertiary"
            onClick={this.props.closeModal}>
            Close
          </Button>
        </div>
      </Modal>
    );
  }
}

UnauthorizedErrorModal.propTypes = propTypes;
